import { WEB_STORAGE_KEYS } from '@/constants/webStorageKeys';
import {
    getItemFromLocalStorage,
    storeItemInLocalStorage,
} from '@/services/webStorage/localStorage';

type OrganisationId = string;

function removeSubscriptionExpiredModalShown(
    organisationId: OrganisationId,
): void {
    const values =
        getItemFromLocalStorage<Record<OrganisationId, boolean>>(
            WEB_STORAGE_KEYS.subscription_expired_modal_shown,
        ) ?? {};
    delete values?.[organisationId];

    storeItemInLocalStorage(
        WEB_STORAGE_KEYS.subscription_expired_modal_shown,
        values,
    );
}

function addSubscriptionExpiredModalShown(
    organisationId: OrganisationId,
    value: boolean,
): void {
    const values =
        getItemFromLocalStorage<Record<OrganisationId, boolean>>(
            WEB_STORAGE_KEYS.subscription_expired_modal_shown,
        ) ?? {};

    storeItemInLocalStorage(WEB_STORAGE_KEYS.subscription_expired_modal_shown, {
        ...values,
        [organisationId]: value,
    });
}

function getSubscriptionExpiredModalShown(
    organisationId: OrganisationId,
): boolean | undefined {
    const values = getItemFromLocalStorage<Record<OrganisationId, boolean>>(
        WEB_STORAGE_KEYS.subscription_expired_modal_shown,
    );
    return values?.[organisationId];
}

export {
    removeSubscriptionExpiredModalShown,
    addSubscriptionExpiredModalShown,
    getSubscriptionExpiredModalShown,
};
